import styled from 'styled-components';

import {
  COLOR_BORDER_GREY,
  COLOR_BLUE,
  COLOR_GREY_040,
  COLOR_BLUE_040,
  COLOR_BLUE_050,
  COLOR_MENU_BACKGROUND,
  COLOR_RED,
} from '@common/assets/styles/colors';

const InputSC = styled.div`
  display: flex;
  align-items: center; // TODO WHY
  color: ${COLOR_BLUE};

  input {
    display: block;
    width: 100%;
    border: none;
    outline: none;

    // TODO MAYBE FIX?
    &:disabled {
      border-color: ${COLOR_BORDER_GREY};
      color: ${COLOR_GREY_040};
    }

    &::placeholder {
      color: ${COLOR_BLUE_050};
    }
  }
`;

export const InputLinedSC = styled(InputSC)`
  background: transparent;
  border-bottom: 1px solid ${COLOR_BLUE_040};
  height: 40px;

  &:hover,
  &:active,
  &:focus {
    border-bottom: 1px solid ${COLOR_BLUE};
  }

  &.has-error {
    border-bottom: 1px solid ${COLOR_RED};
  }
`;

export const InputRoundedSC = styled(InputSC)`
  border-radius: 8px;
  background: ${COLOR_MENU_BACKGROUND};
  padding: 0 10px;
  height: 40px;

  input {
    background-color: transparent;
  }

  &.has-error {
    border: 1px solid ${COLOR_RED};
    margin-bottom: 7px;
  }
`;
